/**
 * Generates the toolbar configuration for TinyMCE editor
 * @param {boolean} notDisplayTools - Whether to hide all toolbar tools
 * @param {boolean} disableInlineImages - Whether to disable inline images
 * @param {function} onAiButtonClick - AI button click callback if available
 * @returns {boolean|string} - Toolbar configuration string or false if tools should not be displayed
 */
export const getToolbarConfig = (
  notDisplayTools,
  disableInlineImages,
  onAiButtonClick,
) => {
  if (notDisplayTools) {
    return false;
  }

  return (
    'h1 h2 h3 bold italic underline forecolor backcolor bullist numlist ' +
    `alignleft aligncenter alignright alignjustify lineheight link ${
      !disableInlineImages ? 'quickimage' : ''
    } ${onAiButtonClick ? 'ai-custom-button' : ''}`
  );
};
